module.exports = __webpack_public_path__ + "error500.png";